module.exports = __webpack_public_path__ + "static/media/plant.e3e78c1b.png";